<template>
  <async-loader v-if="cloudCannonContentLoading"/>
  <div class="content-page" v-else>
<!--    <cloud-cannon-content-->
<!--      :content="cloudCannonContent.header"-->
<!--      :content-loading="cloudCannonContentLoading"-->
<!--    />-->
    <cloud-cannon-content
      :content="cloudCannonContent.content"
      :content-loading="cloudCannonContentLoading"
    />
<!--    <cloud-cannon-content-->
<!--      :content="cloudCannonContent.footer"-->
<!--      :content-loading="cloudCannonContentLoading"-->
<!--    />-->
  </div>
</template>

<script>
  import fetchable from '@mixins/fetchable'
  import CloudCannonable from '@mixins/CloudCannonable'
  import AsyncLoader from '../components/molecules/AsyncLoader'

  export default {
    components: { AsyncLoader },
    mixins: [fetchable, CloudCannonable],
    computed: {
      fetchers () {
        return [
          {
            action: 'cloudCannon/GET_CLOUD_CANNON_CONTENT',
            options: {
              cloudCannonResource: `/${this.$route.params.contentPageName}.json`
            },
            config: {
              root: true
            }
          }
        ]
      }
    }
  }
</script>
